/**
 * Created by alberto on 2015-01-20.
 */
define('boxes/events/feeEvent',[],function () {
    'use strict';

	var METHOD_CREDIT_CARD = 'CREDIT-CARD';

    function getBonusId(paymentBox) {
        if (typeof(paymentBox.model.bonusData) === 'undefined') {
            return '';
        }
        return paymentBox.model.bonusData.id;
    }

    function updateFee(paymentBox) {
        var paymentController = paymentBox.model.paymentController;
        var amount = paymentBox.$box.find('.amount-box input').val();
        var data = {
            selectedFormMethodId: paymentController.selectedFormMethodId,
            amount: amount,
            selectedCurrency: fetchCurrency(paymentBox),
            bonusId: getBonusId(paymentBox),
			formTemplateCode: paymentController.getSelectedFormTemplate().paymentMethod.formTemplateCode,
			aid: fetchAccountId(paymentBox, paymentController.getSelectedFormTemplate())
        };
        paymentBox.$controller.trigger(feeEvent.UPDATE_FEE, data);
    }

    function updateFeeWithAmount(paymentBox, amount) {
        var paymentController = paymentBox.model.paymentController;
        var formTemplate = paymentController.getSelectedFormTemplate();

        var data = {
            selectedFormMethodId: paymentController.selectedFormMethodId,
            amount: amount,
            selectedCurrency: fetchCurrency(paymentBox),
            bonusId: getBonusId(paymentBox),
			formTemplateCode: formTemplate.paymentMethod.formTemplateCode,
            aid: fetchAccountId(paymentBox, formTemplate)
        };
        paymentBox.$controller.trigger(feeEvent.UPDATE_FEE, data);
    }

    function resetFee(paymentBox, selectedId) {
		var amount = paymentBox.$box.find('.amount-box input').val();
		if (isNaN(parseFloat(amount)) || !isFinite(amount)) {
			amount = 0;
		}
        var paymentController = paymentBox.model.paymentController;
        var formTemplate = paymentController.getSelectedFormTemplate();

        var data = {
            selectedId: selectedId,
			amount: amount,
            currency: fetchCurrency(paymentBox),
            bonusId: getBonusId(paymentBox),
			formTemplateCode: formTemplate.paymentMethod.formTemplateCode,
            aid: fetchAccountId(paymentBox, formTemplate)
        };
        paymentBox.$controller.trigger(feeEvent.RESET_FEE, data);
    }

    function fetchCurrency(paymentBox) {
        var currency;
        var paymentController = paymentBox.model.paymentController;
        if (typeof(paymentController.selectedCurrency) === 'undefined') {
            currency = getAllowedCurrency(paymentController);
        } else {
            currency = paymentController.selectedCurrency;
        }
        return currency;
    }

    function getAllowedCurrency(paymentController) {
        var selectedFormTemplate = paymentController.getSelectedFormTemplate();
        var allowedCurrencies;
        if (selectedFormTemplate.formTemplateData !== undefined) {
            allowedCurrencies = selectedFormTemplate.formTemplateData.currencies;
        }
        var currencyToUse;
        var playerCurrency = paymentController.playerCurrency;
        if (allowedCurrencies !== undefined) {
			var playerCurrencyAllowed = false;
			for (var j = 0; j < allowedCurrencies.length; j++) {
				if (allowedCurrencies[j].value === playerCurrency) {
					playerCurrencyAllowed = true;
					break;
				}
			}
			if (playerCurrencyAllowed) {
				currencyToUse = playerCurrency;
			} else {
				currencyToUse = allowedCurrencies[0].value;
			}
		}
        if(currencyToUse === undefined) {
        	currencyToUse = playerCurrency;
		}
        return currencyToUse;
    }

    //This important for credit cards mostly
    function fetchAccountId(paymentBox, formTemplate){
        var formTemplateCode = formTemplate.paymentMethod.formTemplateCode;
		var $paymentMethodForm = paymentBox.$box.find(formTemplate.getSelectorClass());
		var selector = 'select[name="aid"]';
		if (formTemplateCode === METHOD_CREDIT_CARD){
			selector = 'select[name="cid"]';
		}
		var accountElement = $paymentMethodForm.find(selector);
        var accountId = accountElement.val();
        return accountId;
    }

    var feeEvent = {};
    feeEvent.RESET_FEE = 'RESET_FEE';
    feeEvent.UPDATE_FEE = 'UPDATE_FEE';
    feeEvent.UPDATE_TOOLTIP = 'UPDATE_TOOLTIP';
    feeEvent.UPDATE_FEEOVER = 'UPDATE_FEEOVER';
    feeEvent.resetFee = resetFee;
    feeEvent.updateFee = updateFee;
    feeEvent.updateFeeWithAmount = updateFeeWithAmount;
    return feeEvent;
});

